import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AutopaySteps } from './autopay-steps.enum';

@Component({
  selector: 'app-autopay-steps',
  templateUrl: './autopay-steps.component.html',
  styleUrls: ['./autopay-steps.component.scss'],
})
export class AutopayStepsComponent {
  @Input() currentAutopayStep: number;
  @Input() isStepOneCompleted: boolean;
  @Input() isStepTwoCompleted: boolean;
  @Input() isStepThreeCompleted: boolean;
  @Output() changeAutopayStepEmit: EventEmitter<number> = new EventEmitter();
  readonly autopaySteps = AutopaySteps;
  constructor() {}

  changeAutopayStep(step: number) {
    this.changeAutopayStepEmit.emit(step);
  }
}
